import React, { useState } from 'react';
import styled from 'styled-components';
import { useProjectElementListStore } from '../../shared/store/projectElementStore';
import { DisplayAlignment, DisplaySize, ImageStyle, ModalType } from '../../shared/enum/EnumRepository';
import { WorkDetailData } from '../../shared/dto/EntityRepository';
import { convertS3UrlToCloudFrontUrl } from '../../shared/aws/awsHelper';
import OptimizedMoleculeImg from '../../shared/component/molecule/OptimizedMoleculeImg';
import { StyledImgProps } from '../../shared/dto/StyleCompRepository';
import { ImgInPeWrapper, WorkImageForLandscape, WorkImageForPortrait } from './WorkImgInPe';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import fullIcon from '../../asset/icon/full_image.png';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { useEditMode } from '../../shared/hooks/useEditMode';

export interface DetailImgInPeProps {
  peId: string;
  alignment: DisplayAlignment;
  displaySize: DisplaySize;
  data: WorkDetailData;
  priority: boolean;
  imageStyle: ImageStyle;
}

const DetailImgInPe: React.FC<DetailImgInPeProps> = ({ peId, alignment, displaySize, data, priority, imageStyle }) => {
  const { isEditMode } = useEditMode();
  const handleImageChange = useProjectElementListStore((s) => s.updateImage);
  const { setStandardModal } = useModalStore();
  const [isHovered, setIsHovered] = useState(false);
  const convertedCloudFrontUrl = convertS3UrlToCloudFrontUrl(data.uploadFile.originUrl);
  const imageRatio = data.uploadFile?.width && data.uploadFile?.height
    ? data.uploadFile.width / data.uploadFile.height
    : undefined;

  const getStyledImage = () => {
    if (imageStyle === ImageStyle.LANDSCAPE) {
      return WorkImageForLandscape as React.ComponentType<StyledImgProps>;
    } else {
      return WorkImageForPortrait as React.ComponentType<StyledImgProps>;
    }
  };

  const showOriginImg = () => {
    setStandardModal({
      modalType: ModalType.ORIGIN_IMG,
      title: `${data.description}`,
      value: convertedCloudFrontUrl,
      handleChange: () => { },
      option: data.uploadFile.allowDownload
    });
  }

  return (
    <ImgInPeWrapper
      $alignment={alignment || DisplayAlignment.CENTER}
      $displaySize={displaySize || DisplaySize.BIG}
      $imageStyle={imageStyle || ImageStyle.LANDSCAPE}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
        {!isEditMode && (
          <BtnContainer2 $isHovered={isHovered}>
            <UniversalIconBtn 
              size="fit" 
              border={true} 
              backgroundImg={fullIcon} 
              onClick={showOriginImg} />
          </BtnContainer2>  
        )}
      <OptimizedMoleculeImg
        srcUrl={convertedCloudFrontUrl}
        alt={data.description}
        displaySize={displaySize}
        displayAlignment={alignment || DisplayAlignment.CENTER}
        handleChange={(originUrl: string, width: number, height: number) => handleImageChange(
          peId,
          originUrl,
          width,
          height
        )}
        StyledImg={getStyledImage()}
        priority={priority}
        imageRatio={imageRatio}
      />
    </ImgInPeWrapper>
  );
};

const BtnContainer2 = styled.div<{ $isHovered: boolean }>`
  position: absolute;
  right: 0.5vh;
  top: 0.5vh;
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5vh;
  opacity: ${({ $isHovered }) => $isHovered ? 1 : 0};
  cursor: ${({ $isHovered }) => $isHovered ? 'pointer' : 'none'};
  pointer-events: ${({ $isHovered }) => $isHovered ? 'auto' : 'none'};
  transition: all 0.3s ease-in-out;
`

export default DetailImgInPe;
